<template>
    <i
        @click="openPageSlidePopup"
        class="crown-icon fas fa-crown font-size-12 shadow-text-none absolute pl-4 cursor-pointer"
    >
    </i>
</template>
<script>
export default {
    methods: {
        openPageSlidePopup() {
            const openPageEvent = new CustomEvent('page-open', {
                detail: {
                    slug: 'question-types'
                }
            })

            window.dispatchEvent(openPageEvent)
        }
    }
}
</script>
